export const getResourceIdFromUrl = (resource: string): string | undefined => {
    const path = window.location.pathname;
    const split = path.split("/");
    const index = split.indexOf(resource);
    return split?.[index + 1];
};
